import { BaseApi, BaseApiBlob } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const consultarIngresosPssUrl = "api/v1/websalud/primeraars/ingresos";

const consultarDiasHospitalariosUrl =
  "api/v1/websalud/primeraars/ingresos/diashospitalarios";

const consultarCoberturasCierreCuentaUrl =
  "/api/v1/websalud/primeraars/ingresos/coberturas";

const eliminarCoberturaUrl =
  "api/v1/websalud/primeraars/ingresos/cobertura";

const buscarCuentasCerradasUrl =
  "api/v1/websalud/primeraars/ingresos/cuentas/cierre";

const validarCoberturaUrl =
  "api/v1/websalud/primeraars/ingresos/cobertura/validacion";

const validarServicioAmbulatorioUrl =
  "api/v1/websalud/primeraars/ingresos/servicio/validacion/ambulatorio";

const consultarTipoPssNoMedicoUrl =
  "/api/v1/websalud/primeraars/prestadores/tipopssnomedico";

const validarAfiliadoVigenteUrl =
  "api/v1/websalud/primeraars/ingresos/asegurado/vigente";

const guardarEgresoUrl =
  "api/v1/websalud/primeraars/ingresos/egreso";

const consultarReclamantesUrl =
  "api/v1/websalud/primeraars/ingresos/reclamantes";

const calcularOxigenoUrl =
  "api/v1/websalud/primeraars/ingresos/oxigeno/calculo";

const consultarCierresCuentasUrl =
  "api/v1/websalud/primeraars/ingresos/cuentas/cierre";

const consultarEstatusHojaQuirurgicaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consulta-estatus-hojaqx";

const consultarDetalleCoberturaUrl =
  "api/v1/websalud/primeraars/hojaquirurgica/consultadetallecobertura";

const validarIngresoExistenteUrl =
  "api/v1/websalud/primeraars/ingresos/existente/validacion";

const consultarPlanesEgresoUrl =
  "api/v1/websalud/primeraars/ingresos/planes/egreso";

const consultarPlanesEgreso = (request) => {
  const params = {
    Ano: request.Ano,
    Compania: request.Compania,
    Pss: request.Pss,
  };
  return InterceptToken(BaseApi.get, consultarPlanesEgresoUrl, params).then(
    (response) => response.data
  );
};

const consultarCierresCuentas = (request) => {
  // Construir query params - siempre enviar parámetros obligatorios
  const params = {
    CodigoReclamante: request.CodigoReclamante,
    FechaSalidaInicial: request.FechaSalidaInicial,
    FechaSalidaFinal: request.FechaSalidaFinal,
    Compania: request.Compania || 30,
    NumeroPagina: request.NumeroPagina || 1,
    TamanoPagina: request.TamanoPagina || 10,
  };
  
  // Agregar parámetros opcionales solo si existen en el request (no undefined)
  if (request.FechaIngresoDesde !== undefined && request.FechaIngresoDesde !== null && request.FechaIngresoDesde !== "") {
    params.FechaIngresoDesde = request.FechaIngresoDesde;
  }
  if (request.FechaIngresoHasta !== undefined && request.FechaIngresoHasta !== null && request.FechaIngresoHasta !== "") {
    params.FechaIngresoHasta = request.FechaIngresoHasta;
  }
  if (request.Secuencial !== undefined && request.Secuencial !== null && request.Secuencial !== "" && request.Secuencial !== 0) {
    params.Secuencial = request.Secuencial;
  }
  if (request.Ano !== undefined && request.Ano !== null && request.Ano !== "") {
    params.Ano = request.Ano;
  }
  if (request.NumeroPlastico !== undefined && request.NumeroPlastico !== null && request.NumeroPlastico !== "" && request.NumeroPlastico !== 0) {
    params.NumeroPlastico = request.NumeroPlastico;
  }
  if (request.Servicio !== undefined && request.Servicio !== null && request.Servicio !== "" && request.Servicio !== 0) {
    params.Servicio = request.Servicio;
  }
  if (request.Cedula !== undefined && request.Cedula !== null && request.Cedula !== "") {
    params.Cedula = request.Cedula;
  }
  if (request.Plan !== undefined && request.Plan !== null && request.Plan !== "" && request.Plan !== 0) {
    params.Plan = request.Plan;
  }
  if (request.PssHonorario !== undefined && request.PssHonorario !== null && request.PssHonorario !== "" && request.PssHonorario !== 0) {
    params.PssHonorario = request.PssHonorario;
  }
  
  return InterceptToken(BaseApi.get, consultarCierresCuentasUrl, params).then(
    (response) => response.data
  );
};

const consultarEstatusHojaQuirurgica = (request) => {
  const { numeroIngreso, codigoPss, codigoAseg } = request;
  
  const params = {
    numeroIngreso: Number(numeroIngreso) || 0,
    codigoPss: Number(codigoPss) || 0,
    codigoAseg: Number(codigoAseg) || 0,
  };
  return InterceptToken(BaseApi.get, consultarEstatusHojaQuirurgicaUrl, params).then(
    (response) => {
      return response.data;
    }
  ).catch((error) => {
    throw error;
  });
};

const consultarDetalleCobertura = (request) => {
  const { secuencial } = request;
  
  const params = {
    Secuencial: Number(secuencial) || 0,
  };
  
  return InterceptToken(BaseApi.get, consultarDetalleCoberturaUrl, params).then(
    (response) => {
      return response.data;
    }
  ).catch((error) => {
    throw error;
  });
};

const consultarIngresosPss = (request) =>
  InterceptToken(BaseApi.get, consultarIngresosPssUrl, request).then(
    (response) => response.data
  );

const consultarDiasHospitalarios = () =>
  InterceptToken(BaseApi.get, consultarDiasHospitalariosUrl).then(
    (response) => response.data
  );

const consultarCoberturasCierreCuenta = (request) => {
  const params = {
    Compania: request.Compania,
    Reclamante: request.Reclamante,
    Servicio: request.Servicio,
    TipoReclamante: request.TipoReclamante,
    Plan: request.Plan,
    tamanoPagina: request.tamanoPagina || 10,
    numeroPagina: request.numeroPagina || 1,
  };

  // Agregar cobertura solo si se proporciona
  if (request.cobertura != null && request.cobertura !== "") {
    params.cobertura = Number(request.cobertura);
  }

  return InterceptToken(BaseApi.get, consultarCoberturasCierreCuentaUrl, params).then(
    (response) => response.data
  );
};

const eliminarCobertura = async (request) => {
  const body = {
    ano: Number(request.ano),
    compania: Number(request.compania),
    ramo: Number(request.ramo),
    secuencial: Number(request.secuencial),
    cobertura: Number(request.cobertura),
  };

  const response = await InterceptToken(BaseApi.delete, eliminarCoberturaUrl, body);
  return response.data;
};

const buscarCuentasCerradas = (request) =>
  InterceptToken(BaseApi.get, buscarCuentasCerradasUrl, {
    FechaInicial: request.FechaInicial,
    FechaFinal: request.FechaFinal,
    Compania: request.Compania,
    CodigoReclamante: request.CodigoReclamante,
    Ano: request.Ano,
    Secuencial: request.Secuencial,
    NumeroPagina: request.NumeroPagina,
    TamanoPagina: request.TamanoPagina,
    Asegurado: request.Asegurado,
    TipoAfiliado: request.TipoAfiliado,
    FechaSalida: request.FechaSalida,
  }).then((response) => response.data);

const validarCobertura = async (request) => {
  const body = {
    ano: Number(request.ano),
    compania: Number(request.compania),
    ramo: Number(request.ramo),
    secuencial: Number(request.secuencial),
    secuenciaPoliza: Number(request.secuenciaPoliza),
    plan: Number(request.plan),
    servicio: Number(request.servicio),
    codigoAsegurado: Number(request.codigoAsegurado),
    tipoAsegurado: request.tipoAsegurado || "",
    fechaSalida: request.fechaSalida || null,
    cobertura: Number(request.cobertura),
    fechaServicio: request.fechaServicio,
    frecuencia: Number(request.frecuencia),
    sexo: request.sexo || "",
    estadoCivil: request.estadoCivil || "",
    fechaNacimiento: request.fechaNacimiento || null,
    tipoReclamante: request.tipoReclamante || "",
    reclamante: Number(request.reclamante),
    montoReclamado: Number(request.montoReclamado),
    checkCirugia: request.checkCirugia || "N",
    categoriaAsegurado: request.categoriaAsegurado || "",
    secuenciaAsegurado: Number(request.secuenciaAsegurado || 0),
  };

  const response = await InterceptToken(BaseApi.post, validarCoberturaUrl, body);
  return response.data;
};

const validarServicioAmbulatorio = (request) =>
  InterceptToken(BaseApi.get, validarServicioAmbulatorioUrl, {
    Ano: request.Ano,
    Compania: request.Compania,
    Ramo: request.Ramo,
    Secuencial: request.Secuencial,
    Reclamante: request.Reclamante,
    Servicio: request.Servicio,
  }).then((response) => response.data);

const consultarTipoPssNoMedico = (request) => {
  const codigoPss = request?.CodigoPss || request?.codigoPss;
  
  if (!codigoPss || Number(codigoPss) === 0) {
    return Promise.reject({
      respuesta: {
        codigo: "400",
        mensaje: "Código PSS no válido"
      }
    });
  }

  return InterceptToken(BaseApi.get, consultarTipoPssNoMedicoUrl, {
    CodigoPss: codigoPss,
  }).then((response) => response.data);
};

const validarAfiliadoVigente = async (request) => {
  const body = {
    compania: Number(request.compania),
    numeroPlastico: Number(request.numeroPlastico),
    fechaVersion: request.fechaVersion,
  };

  const response = await InterceptToken(BaseApi.post, validarAfiliadoVigenteUrl, body);
  return response.data;
};

const guardarEgreso = async (request) => {
  const body = {
    origen: request.origen || "WEBSALUD",
    ano: Number(request.ano),
    compania: Number(request.compania),
    ramo: Number(request.ramo),
    secPol: Number(request.secPol),
    plan: Number(request.plan),
    asegurado: Number(request.asegurado),
    secuencia: Number(request.secuencia || 1),
    noIngreso: request.noIngreso,
    fecIngreso: request.fecIngreso,
    fecEgreso: request.fecEgreso,
    fecTra: request.fecTra,
    horaTra: request.horaTra,
    codMedicoIngreso: Number(request.codMedicoIngreso),
    codDiagnosticoIngreso: request.codDiagnosticoIngreso || "Z000",
    estatusEgreso: Number(request.estatusEgreso || 1),
    codigoPss: Number(request.codigoPss),
    tipoReclamante: request.tipoReclamante,
    correoPss: request.correoPss,
    usuario: request.usuario,
    usuUAct: request.usuUAct,
    fecUAct: request.fecUAct,
    comentarioEgreso: request.comentarioEgreso || "Egreso registrado via WS",
    observacionSpool: request.observacionSpool || "Sin observaciones",
  };

  const response = await InterceptToken(BaseApi.post, guardarEgresoUrl, body);
  return response.data;
};

const consultarReclamantes = (request) =>
  InterceptToken(BaseApi.get, consultarReclamantesUrl, {
    TipoReclamante: request.TipoReclamante,
    Reclamante: request.Reclamante,
    Compania: request.Compania || 30,
  }).then((response) => response.data);

const calcularOxigeno = (request) =>
  InterceptToken(BaseApi.post, calcularOxigenoUrl, request).then(
    (response) => response.data
  );
const insertarCoberturaUrl =
  "api/v1/websalud/primeraars/ingresos/coberturas";

const insertarCobertura = async (request) => {
  const body = {
    ano: Number(request.ano),
    secuencial: Number(request.secuencial),
    secuencia: Number(request.secuencia || 1),
    servicio: Number(request.servicio),
    tipoCobertura: Number(request.tipoCobertura),
    cobertura: Number(request.cobertura),
    fechaServicio: request.fechaServicio,
    frecuencia: Number(request.frecuencia),
    montoReclamadoCobertura: Number(request.montoReclamadoCobertura),
    reserva: Number(request.reserva || 0),
    estatus: Number(request.estatus || 1),
    limiteCobertura: Number(request.limiteCobertura),
    tipoAfiliado: request.tipoAfiliado || "NO_MEDICO",
    codigoCentro: Number(request.codigoCentro),
    porcientoCobertura: Number(request.porcientoCobertura),
    usuarioTransaccion: request.usuarioTransaccion,
    fechaTransaccion: request.fechaTransaccion,
    montoPagoCobertura: Number(request.montoPagoCobertura),
    ramoIngreso: Number(request.ramoIngreso),
    montoPagoAfiliado: Number(request.montoPagoAfiliado),
    excedenteCopago: Number(request.excedenteCopago || 0),
    fechaIngresoCobertura: request.fechaIngresoCobertura,
    usuarioIngresoCobertura: request.usuarioIngresoCobertura,
    codigoCompania: Number(request.codigoCompania),
  };

  const response = await InterceptToken(BaseApi.post, insertarCoberturaUrl, body);
  return response.data;
};

const cerrarCuentaClinicaUrl =
  "api/v1/websalud/primeraars/ingresos/cuenta/cerrar";

const cambiarServicioUrl =
  "api/v1/websalud/primeraars/ingresos/servicio/cambio";

const cerrarCuentaClinica = async (request) => {
  const body = {
    ano: Number(request.ano),
    secuencial: Number(request.secuencial),
    tipoReclamante: request.tipoReclamante || "",
    codigoReclamante: Number(request.codigoReclamante),
    tipoAsegurado: request.tipoAsegurado || "",
    codigoAsegurado: Number(request.codigoAsegurado),
    frecuenciaAsegurado: Number(request.frecuenciaAsegurado || 0),
    numeroPlastico: Number(request.numeroPlastico),
    codigoCompania: Number(request.codigoCompania || 30),
    ramoPoliza: Number(request.ramoPoliza),
    secuencialPoliza: Number(request.secuencialPoliza),
    plan: Number(request.plan),
    fechaDia: request.fechaDia,
    fechaTransaccion: request.fechaTransaccion,
    usuario: request.usuario,
    servicio: Number(request.servicio),
    riesgoLaboral: request.riesgoLaboral || "",
    simultaneo: request.simultaneo || "N",
    procesoComentario: request.procesoComentario || "",
    motivoEgreso: request.motivoEgreso ?? "",
  };

  const response = await InterceptToken(BaseApi.post, cerrarCuentaClinicaUrl, body);
  return response.data;
};

const cambiarServicio = async (request) => {
  const body = {
    anoReporte: Number(request.anoReporte),
    companiaPoliza: Number(request.companiaPoliza),
    ramoPoliza: Number(request.ramoPoliza),
    secuencialReporte: Number(request.secuencialReporte),
    servicioVigente: Number(request.servicioVigente),
  };

  const response = await InterceptToken(BaseApi.post, cambiarServicioUrl, body);
  return response.data;
};

const validarIngresoExistente = async (request) => {
  const body = {
    ano: Number(request.ano) || 0,
    secuencial: Number(request.secuencial) || 0,
    numeroPlastico: Number(request.numeroPlastico) || 0,
    codigoAsegurado: Number(request.codigoAsegurado) || 0,
    codigoDependiente: Number(request.codigoDependiente) || 0,
  };

  const response = await InterceptToken(BaseApi.post, validarIngresoExistenteUrl, body);
  return response.data;
};

const descargarVoucherEgresoUrl =
  "api/v1/websalud/primeraars/ingresos/voucher/egreso";

const descargarVoucherEgreso = async (request) => {
  const { Ano, Compania, Ramo, Secuencial, CodigoPss, TipoReclamante, EsMatricial } = request;

  const params = {
    Ano: Number(Ano) || 0,
    Compania: Number(Compania) || 30,
    Ramo: Number(Ramo) || 0,
    Secuencial: Number(Secuencial) || 0,
    CodigoPss: Number(CodigoPss) || 0,
    TipoReclamante: TipoReclamante || "NO_MEDICO",
    EsMatricial: EsMatricial === true || EsMatricial === "true",
  };

  const response = await InterceptToken(BaseApiBlob.get, descargarVoucherEgresoUrl, params);

  // Verificar que la respuesta sea un blob válido
  if (response.data && response.data instanceof Blob) {
    // Crear un enlace temporal para descargar el archivo
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Voucher_${Secuencial}_${CodigoPss}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } else {
    throw new Error('La respuesta no es un archivo válido');
  }

  return response;
};

const EgresosService = {
  consultarIngresosPss,
  consultarDiasHospitalarios,
  consultarDetalleCobertura,
  consultarCoberturasCierreCuenta,
  eliminarCobertura,
  buscarCuentasCerradas,
  validarCobertura,
  validarServicioAmbulatorio,
  consultarTipoPssNoMedico,
  validarAfiliadoVigente,
  guardarEgreso,
  consultarReclamantes,
  calcularOxigeno,
  insertarCobertura,
  cerrarCuentaClinica,
  consultarCierresCuentas,
  consultarPlanesEgreso,
  cambiarServicio,
  consultarEstatusHojaQuirurgica,
  validarIngresoExistente,
  descargarVoucherEgreso,
};

export default EgresosService;
